var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"lighten-4 fix-font"},[(_vm.app)?_c('Menu'):_vm._e(),_c('v-container',{staticClass:"my-15 px-0",attrs:{"fluid":""}},[_c('keep-alive',[_c('router-view')],1)],1),(_vm.loading)?_c('Startup'):_vm._e(),_c('Tours')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }